import { RendererStyleFlags2 } from '@angular/core';
import { fromEvent, of, race, Subscription } from 'rxjs';
import { buffer, bufferCount, debounceTime, filter, first, map, repeat } from 'rxjs/operators';
import { PickingResult } from '../lookup-grid-options';
import { LookupGridComponent } from '../lookup-grid.component';

export class LookupDialogManager {

    private lookupInit: Subscription = null;
    private _loadDataWhenOpen = true;
    private _navSelectedId = '';
    private _selectFirstInNav = false;
    private dialogClosedSubscription: Subscription = null;
    private dialogOpenedSubscription: Subscription = null;
    
    private keyDownHandler = null;
    private _okbtnclick$: Subscription = null;

    constructor(private ins: LookupGridComponent) { }

    private unsubscribes(){
        if (this.lookupInit) {
            this.lookupInit.unsubscribe();
            this.lookupInit = null;
        }

        if (this.dialogClosedSubscription) {
            this.dialogClosedSubscription.unsubscribe();
            this.dialogClosedSubscription = null;
        }

        if (this.dialogOpenedSubscription) {
            this.dialogOpenedSubscription.unsubscribe();
            this.dialogOpenedSubscription = null;
        }

    }
    // å¸®å©çªå£å³é­ååä¸äºæ¸çå·¥ä½
    dialogClosed() {
        if (this.ins.displayText !== this.ins.originalText && !this.ins.nosearch) {
            this.ins.displayText = this.ins.originalText;
            this.ins.setModelValue(this.ins.displayText);
        }
        if (this.ins.componentRef) {
            this.ins.componentRef.destroy();
            this.ins.componentRef = null;
        }

        if (this.ins.favoritesComponentRef) {
            this.ins.favoritesComponentRef.destroy();
            this.ins.favoritesComponentRef = null;
        }

        if (this.ins.contentContainer) {
            this.ins.contentContainer.clear();
        }

        if (this.ins.centerContainer) {
            this.ins.centerContainer.clear();
        }

        if (this.ins.leftComponentRef) {
            this.ins.leftComponentRef.destroy();
            this.ins.leftComponentRef = null;
        }

        if (this.ins.leftContainer) {
            this.ins.leftContainer.clear();
        }


        this.ins.isShow = false;
        this.ins.isTextChange = false;
        if (this.ins.dialog) {
            this.ins.content = null;
        }

        this.ins.navigationFilter = null;

        this.ins.lookupUtils.pendingEnd();

        if (this.ins.helpId) {
            this.ins.displayType = '';
        }


        this.unsubscribes();

        // this.ins.items = [];
        this.ins.favoriteItems = [];
        this.ins.lookupSelectionSer.initFavoriteItems([]);

        this.ins.isTabChanged = false;

        if (this.ins.uri) {
            this.ins.items = [];
        }
        this.ins._searchState = null;


        this.ins.pageIndex = 1;

        this.ins.loadDataWhenOpen = this._loadDataWhenOpen;
        this.ins.navSelectedIds = this._navSelectedId;
        this.ins.selectFirstInNav = this._selectFirstInNav;

        // this.ins.isGetAllChidlNodes = this.ins.useReturnAllChildNodes;
        this.ins.isGetAllChidlNodes = false;

        this.ins.enableGetAllChildNodes = true;

        // ä¿å­ä¸ªæ§åæ°æ®
        if (this.ins.usePersionalConf && this.ins.favoriteDataFrom !== 'locale') {
            this.ins.httpMgr.submitFavoriteData('dialog closed event.');
        }

        if (this.keyDownHandler) {
            this.keyDownHandler();
            this.keyDownHandler = null;
        }
        if (this.ins.inputGroup) {
            this.ins.inputGroup.focus();
        }

        this.ins.userInitialConfig.reset();

        this.ins.treeInfo = this.ins._treeInfo_;

        this.ins.lookupUtils.destroy();
        this.ins.dialogClosed.emit();

        if (this.ins.includeSubordinates$$) {
            this.ins.includeSubordinates$$.unsubscribe();
            this.ins.includeSubordinates$$ = null;
        }

        this.ins.conditions = [];
        

        this.ins.searching = false;

        if (this.ins.dtEventMgr) {
            this.ins.dtEventMgr['_sortState'] = null;
        }

        if (this.ins.ttEventMgr) {
            this.ins.ttEventMgr['_sortState'] = null;
        }

        if (this._okbtnclick$) {
            this._okbtnclick$.unsubscribe();
            this._okbtnclick$ = null;
        }

        // tfs 699878
        if(this.ins.ttEventMgr) {
            this.ins.ttEventMgr['IS_SEARCH_RESULT'] = false;
        }

    }

    onDialogCreated() {
        this._loadDataWhenOpen = this.ins.loadDataWhenOpen;
        this._navSelectedId = this.ins.navSelectedIds;
        this._selectFirstInNav = this.ins.selectFirstInNav;

        this.ins.dialogCreatedSubscription = this.ins.dialogCreated.subscribe(dlg => {
            if (dlg) {
                this.ins.setContainerMargin();
                if (this.ins.dialogOpenedSubscription) {
                    this.ins.dialogOpenedSubscription.unsubscribe();
                }
                if (this.ins.dialogClosedSubscription) {
                    this.ins.dialogClosedSubscription.unsubscribe();
                }
                this.registerDialogEvent();
                if (this.ins.isRecordSize) {
                    const dlgSize = this.ins.personalConfigService.getDialogSize();
                    if (dlgSize) {
                        const { width, height } = dlgSize;
                        this.ins.dialogWidth = width ? width : this.ins.dialogWidth;
                        this.ins.dialogHeight = height ? height : this.ins.dialogHeight;

                        // 20200908 æ´æ°ç°çªå£çå°ºå¯¸ by Lucas
                        dlg.width = this.ins.dialogWidth;
                        dlg.height = this.ins.dialogHeight;
                    }
                }
                dlg.show();
            }
        });

        this.ins.subscriptions.push(this.ins.dialogCreatedSubscription);
    }

    checkDictPickingResult(pr: PickingResult | any) {
        let o = true;
        if (pr === undefined || pr === null || pr === '') {
            o = true;
        }

        if (typeof pr === 'boolean') {
            o = pr;
        }

        let customData, selectedIds, message;
        customData = this.ins.customData;
        selectedIds = this.ins.selectedIds;

        if (typeof pr === 'object') {
            if (pr.showDialog === undefined) {
                o = true;
            } else {
                o = pr.showDialog;
            }

            if (pr.hasOwnProperty('data')) {
                /** ä¿å­å¸®å©åä¼ éçæ°æ® */
                customData = pr.data;
            }
            selectedIds = pr.selectedIds || null;

            if (pr.message) {
                message = pr.message;
            }
        }

        return { show: o, customData, selectedIds, message };
    }

    canOpenDialog(pr: PickingResult | any) {
        const {show, customData, selectedIds, message} = this.checkDictPickingResult(pr);
        this.ins.customData = customData;
        this.ins.selectedIds = selectedIds || null;
        if (message) {
            this.ins.notifyService.warning(message);
        }

        this.ins.isReady = false;
        this.ins.isShow = show;
    }

    getHeight() {
        return this.ins.dialog.size.contentHeight -
                this.ins.containerMargin.bottom -
                this.ins.containerMargin.top -
                (!this.ins.useNewLayout ? (this.ins.useFavorite ? 40 :  0) : 56);
            
    }


    private getMainGridSize() {
        if (this.ins.isDoublleList()) {
            return {
                width: this.ins.dialog.size.width - this.ins.leftPanel.width - 27,
                height: this.getHeight()
            };
        }

        return {
            width: this.ins.dialog.size.width - this.ins.containerMargin.left - this.ins.containerMargin.right,
            height: this.getHeight()
        };
    }

    resetDialogContentHeight() {
        const { header: hHeight, footer: fHeight } = this.ins.dialog.size;
        return this.ins.dialogHeight - hHeight - fHeight -  this.ins.containerMargin.bottom - this.ins.containerMargin.top;
    }


    private registerOkBtnEvent() {
        if (this.ins.okButton) {
            const doubleClickDuration = 250;
            const leftClick$ = fromEvent(this.ins.okButton.nativeElement, 'click').pipe(filter((event: any) => event.button === 0));
            const debounce$ = leftClick$.pipe(debounceTime(doubleClickDuration));
            const clickLimit$ = leftClick$.pipe(bufferCount(2));
            const bufferGate$ = race(debounce$, clickLimit$)
            .pipe(
              // We are only interested in the first event. After that
              // we want to restart.
              first(),
              repeat(),
            );

            this._okbtnclick$ = leftClick$.pipe(
                buffer(bufferGate$),
                // Here we map the buffered events into the length of the buffer
                // If the user clicked once, the buffer is 1. If he clicked twice it is 2
                map(clicks => clicks.length)
            ).subscribe(clicks => {
                this.ins.selectItem();
            });
        }
    }

    /** æ³¨åå¼¹åºçªå£çäºä»¶ */
    private registerDialogEvent() {
        this.dialogOpenedSubscription = this.ins.dialog.opened.subscribe(() => {

            this.ins.dialogContentHeight = this.resetDialogContentHeight();

            this.ins.gridOptions = Object.assign(this.ins.gridOptions, this.getMainGridSize());
            this.ins.dialog.el.nativeElement.querySelector('.ps-content').style.height = '100%';

            if (this.ins.displayType && this.ins.customDisplayType) {
                this.ins.componentRef = this.ins.lookupCmpMgr.createContent(this.ins.gridOptions);
                this.ins.lookupCmpMgr.createFavoriteComponent();
            }

            this.ins.initData();

            // ä¿®æ¹å¸®å©çªå£çç¶æ
            this.ins.lookupUtils.pendingEnd();
            this.ins.dialogOpened.emit();

            // æ³¨åç¡®å®æé®ç¹å»äºä»¶
            this.registerOkBtnEvent();

        });

        this.lookupInit = this.ins.lookupinitializationSubject.subscribe(() => {
            this.enableEqualSearch();
            this.ins.loadDataWhenOpen = true;
            // æ³¨åå¿«æ·é®
            this.registerShortcutKey();
            // çå¬å·¦ä¾§å°ºå¯¸ååäºä»¶
            if (this.ins.leftPanel) {
                if (!this.ins.leftPanel.resizing.observers.length) {
                    const leftPanelResize$ = this.ins.leftPanel.resizing.pipe(
                        debounceTime(50)
                    ).subscribe((s: any) => {
                        const size = {
                            width: this.ins.dialog.size.width - s.size.width - this.ins.getSpaceWidth(true),
                            height: this.getHeight() - this.ins.getFilterBarHeight()
                        }
                        this.ins.componentRef.instance.resize(size);
                        this.ins.leftComponentRef.instance.resize(s.size);
                    });

                    this.ins.subscriptions.push(leftPanelResize$);
                }
                if (this.ins.isDoublleList() && this.ins.leftComponentRef) {
                    this.ins.leftComponentRef.instance.updateScrollPosition();
                }
            }

            if (this.ins.cascadeSelect) {
                const {selectEl, panelRef } = this.ins.cascadeSelect;
                this.ins.cascadeSelect.beforeShow = () => {
                    if (selectEl && panelRef) {
                        panelRef.style.left = `${selectEl.offsetLeft}px`;
                        if (this.ins.localService.localeId.toLocaleLowerCase() == 'en') {
                            panelRef.style.width = 'auto';
                            panelRef.style.maxWidth = '200px'
                        }
                        return of(true);
                    }
                }
            }

            if (this.ins.activeTab == 'favorite' && this.ins.favoritesComponentRef) {
                this.ins.favoritesComponentRef.instance.resize();
            }
        });

        this.dialogClosedSubscription = this.ins.dialog.closed.subscribe(() => {
            // è¾å¥æ¡åååï¼å¼¹åºçªå£æªéæ©æ°æ®å³é­çªå£æ¶ï¼è¿ååå§å¼
            this.ins.dialogMgr.dialogClosed();
        });

        // this.ins.subscriptions.push(this.ins.dialogClosedSubscription);
    }

    private enableEqualSearch() {
        const langs = {
            'zh-CHS': 'ç²¾ç¡®',
            'zh-CHT': 'ç²¾ç¢º',
            'en': 'Exact'
        }
        if (!this.ins.enableMultiFieldSearch && this.ins.showFilterBar && this.ins.displayType.toUpperCase() !== 'TREELIST' && this.ins.enableEqualSearch) {
            const filterRowEl = this.ins.componentRef.instance.el.nativeElement.querySelector('.filter-row');
            filterRowEl.querySelector('.search-text').classList.add('d-flex', 'align-items-center');
            filterRowEl.querySelector('.search-text input-group').classList.add('w-100');
            const searchBoxRef = this.ins.componentRef.instance.inputGroup;
            searchBoxRef.el.nativeElement.insertAdjacentHTML('afterend', `<div class="custom-control custom-checkbox custom-control-inline pr-0 m-0 ml-2 ">
                <input class="custom-control-input" id="farris-lookup_searchtype-equal" type="checkbox">
                <label class="custom-control-label btn-link lookup-checkbox-label" for="farris-lookup_searchtype-equal" 
                style="padding-left:18px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">${langs[this.ins.localService.localeId]}</label>
                </div>`);
            const chkequal = filterRowEl.querySelector('#farris-lookup_searchtype-equal');
            if(chkequal) {
                chkequal['checked'] = this.ins['searchType'] === 'equal';
                chkequal.addEventListener('click', (e: Event) => {
                    this.ins['searchType'] = e.target['checked']? 'equal' : 'like';
                });
            }
        }
    }

    private registerShortcutKey() {
        // åè½¦ï¼ä¸ç¡®å®æé®å¤çé»è¾ä¸è³ã
        const dlgContainerDom = this.ins.dialog.el.nativeElement.querySelector('.farris-modal');

        if (dlgContainerDom && this.ins.shortcutKey && !this.keyDownHandler) {
            this.keyDownHandler = this.ins.eventManager.addEventListener(dlgContainerDom, 'keydown', (e: KeyboardEvent) => {
                e.stopPropagation();
                const { moveUp, moveDown, searchFocus, confirm, nextPager, prevPager, expand, collapse } = this.ins.shortcutKey;
                const arrowKey = [moveUp, moveDown, expand, collapse];
                if (arrowKey.includes(e.code)) {
                    this.ins.componentRef.instance.onKeydownEvent(e);
                } else if (e.key === confirm) {
                    if (e.target['nodeName'] === 'INPUT' && !e.ctrlKey) {
                        return;
                    }
                    this.ins.okButton.nativeElement.click();
                } else if (e.code === searchFocus) { // å¸®å©çªå£æ¥è¯¢è¾å¥æ¡ç¦ç¹
                    e.preventDefault();
                    this.ins.componentRef.instance.inputGroup.focus();
                } else if (!this.ins.isTree() && (e.code === nextPager || e.code === prevPager )) {  // åé¡µ
                    const isNextPager = e.code === nextPager;
                    this.paginationKeyDownHandler(isNextPager);
                }
            });
        }
    }

    private paginationKeyDownHandler(next = true) {
        const datatableRef = this.ins.componentRef.instance;
        const {pageIndex, pageSize, total} = datatableRef;
        const pagerCount = Math.ceil(total / pageSize);

        let newPageNum = pageIndex;
        if (next) {
            newPageNum = newPageNum + 1;
        } else {
            newPageNum = newPageNum - 1;
        }

        if (newPageNum > pagerCount || newPageNum < 1) {
            newPageNum = pageIndex;
        }

        this.ins.componentRef.instance.onPageChange({ pageSize, pageIndex: newPageNum });
    }

}

